import { Container, Paper } from "@mantine/core";

export const MainContainer: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <Container size="sm" py="xl">
    <Paper shadow="xl" p="md" radius="md" withBorder>
      {children}
    </Paper>
  </Container>
);
